export default __webpack_public_path__ + "static/media/saved-messages.ec7e71a5.svg";